import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

import { spaceBeforeCapital } from '@shared/utils';

@Pipe({
  name: 'spaceBeforeCapital',
})
export class SpaceBeforeCapitalPipe implements PipeTransform {
  transform(value: string, capitalizeFirstLetter = false): string {
    return SpaceBeforeCapitalPipe.transform(value, capitalizeFirstLetter);
  }

  static transform(value: string, capitalizeFirstLetter = false): string {
    return spaceBeforeCapital(value, capitalizeFirstLetter);
  }

  transformSelectItems(items: SelectItem[]): SelectItem[] {
    return items.map((x) => ({ label: this.transform(x.label), value: x.value }));
  }
}
